import { Box, Typography } from "@mui/material";

interface Props {
  label: string;
  color?: string;
}

const CustomChip = ({ label, color = "#00B6B9" }: Props) => {
  return (
    <Box
      sx={{
        backgroundColor: color,
        width: "fit-content",
        borderTopLeftRadius: "12px",
        borderTopRightRadius: "12px",
        padding: "0px 12px",
        position: "relative",
        left: "5%",
      }}
    >
      <Typography variant="body1" fontWeight={600} sx={{ color: "#ffffff" }}>
        {label}
      </Typography>
    </Box>
  );
};

export default CustomChip;
